import { createSelector } from 'reselect'
import {
  ExpenseReportModel,
  ExpenseReportResponse,
} from 'src/models/expenseReport.model'
import { UserListModel, UserListResponse } from 'src/models/user.models'
import { RootState } from 'src/redux/createRootReducer'

export const selectExpenseReportResponse = (
  state: RootState,
): Record<string, ExpenseReportResponse> =>
  state.data.expenses.detailReportResponse
export const selectPostingExpenseFromState = (state: RootState): boolean =>
  state.data.expenses.postingExpense

export const selectPostingExpenseErrorFromState = (
  state: RootState,
): string | undefined => state.data.expenses.postingExpenseError

export const selectExpenseReportModelsFromState = createSelector(
  [selectExpenseReportResponse],
  (expenseReportDetailResponse) =>
    Object.values(expenseReportDetailResponse).reduce(
      (acc, curr) => ({
        ...acc,
        [curr.id]: new ExpenseReportModel(curr),
      }),
      {} as Record<string, ExpenseReportModel>,
    ),
)

export const selectExpenseReportsListResponseFromState = (
  state: RootState,
): Record<string, ExpenseReportResponse> => state.data.expenses.listResponses

export const selectExpenseReportsListModelFromState = createSelector(
  [selectExpenseReportsListResponseFromState],
  (expenseReportsListResponse) =>
    Object.values(expenseReportsListResponse).reduce(
      (acc, curr) => ({
        ...acc,
        [curr.id]: new ExpenseReportModel(curr),
      }),
      {} as Record<string, ExpenseReportModel>,
    ),
)

export const selectLatestExpenseReportsListModelFromState = (
  state: RootState,
): ExpenseReportResponse | undefined => {
  return state.data.expenses.latestListResponse !== undefined
    ? new ExpenseReportModel(state.data.expenses.latestListResponse)
    : undefined
}

export const selectSubmitterUsersListResponsesFromState = (
  state: RootState,
): Record<string, UserListResponse> =>
  state.data.expenses.submitterUserListResponses

export const selectSubmitterUsersListModelsFromState = createSelector(
  [selectSubmitterUsersListResponsesFromState],
  (userListResponse) =>
    Object.values(userListResponse).reduce(
      (acc, curr) => ({
        ...acc,
        [curr.id]: new UserListModel(curr),
      }),
      {} as Record<string, UserListModel>,
    ),
)

export const selectSelectedMarkExpensesPaidFromState = (
  state: RootState,
): string[] | undefined => state.data.expenses.selectedMarkExpensesPaid

export const selectSelectedMarkExpensesPaidAmountFromState = (
  state: RootState,
): number | undefined => state.data.expenses.selectedMarkExpensesPaidAmount

export const selectPostMarkingExpenseReportPaid = (state: RootState): boolean =>
  state.data.expenses.postMarkingExpenseReportPaid

export const selectSelectedDeleteExpensesFromState = (
  state: RootState,
): string[] | undefined => state.data.expenses.selectedDeleteExpenses

export const selectSelectedDeleteExpenseReportsFromState = (
  state: RootState,
): string[] | undefined => state.data.expenses.selectedDeleteExpenseReports

export const selectPostMarkingExpenseReportPaidError = (
  state: RootState,
): string | undefined => state.data.expenses.postMarkingExpenseReportPaidError

export const selectDeleteExpenseReportsTopLevelError = (
  state: RootState,
): string | undefined => state.data.expenses.deletingExpenseReportsTopLevelError

export const selectDeletingExpenseReports = (state: RootState): boolean =>
  state.data.expenses.deletingExpenseReports

export const numberOfExpensesFromState = (
  state: RootState,
): number | undefined => state.data.expenses.numberOfExpenses
